module.exports = {
  context: {
    sectionHeading: 'Example Block Implementation',
    images: [
      {
        thumbnail: 'https://via.placeholder.com/600',
        src: 'https://via.placeholder.com/1600',
        alt: 'lorem ipsum dolor sit amet',
        lazy: true,
        width: 600,
        height: 600
      },
      {
        thumbnail: 'https://via.placeholder.com/600',
        src: 'https://via.placeholder.com/1600',
        alt: 'lorem ipsum dolor sit amet',
        lazy: true,
        width: 600,
        height: 600
      },
      {
        thumbnail: 'https://via.placeholder.com/600',
        src: 'https://via.placeholder.com/1600',
        alt: 'lorem ipsum dolor sit amet',
        lazy: true,
        width: 600,
        height: 600
      },
      {
        thumbnail: 'https://via.placeholder.com/600',
        src: 'https://via.placeholder.com/1600',
        alt: 'lorem ipsum dolor sit amet',
        lazy: true,
        width: 600,
        height: 600
      },
      {
        thumbnail: 'https://via.placeholder.com/600',
        src: 'https://via.placeholder.com/1600',
        alt: 'lorem ipsum dolor sit amet',
        lazy: true,
        width: 600,
        height: 600
      },
      {
        thumbnail: 'https://via.placeholder.com/600',
        src: 'https://via.placeholder.com/1600',
        alt: 'lorem ipsum dolor sit amet',
        lazy: true,
        width: 600,
        height: 600
      }
    ]
  }
}
